'use client';

// import cn from '@utils/cn';
// import { GridColFullWidth } from '@constants/layout';
// import { useEffect } from 'react';

// const Hubspot = styled.div`
//     form {
//         display: flex;
//         flex-direction: column;
//         gap: 16px;
//     }

//     div {
//         width: 100%;
//         color: white;
//     }

//     .hs-button {
//         width: 100%;
//         padding: 20px 10px;
//         font-family: Plus Jakarta Sans;
//         font-size: 16px;
//         font-style: normal;
//         font-weight: 600;
//         line-height: 160%; /* 25.6px */
//         letter-spacing: 0.08px;
//         background-color: var(--primary);
//         color: var(--primary-foreground);
//         :hover {
//             cursor: pointer;
//         }
//     }
//     .hs-error-msgs {
//         color: red;
//     }
//     .hs-input {
//         display: flex;
//         width: 100%;
//         height: var(--spacing-12, 48px);

//         padding: var(--spacing-3, 12px) var(--spacing-5, 20px);
//         color: var(--primary-foreground);
//         align-items: center;
//         gap: var(--spacing-25, 10px);
//         border-radius: var(--spacing-2, 8px);
//         border: 1px solid var(--secondary, rgba(255, 255, 255, 0.25));
//         background: var(--input, rgba(255, 255, 255, 0.05));
//     }
// `;
// Postponed for now
export default function CTAEmail() {
  // useEffect(() => {
  //     const script = document.createElement('script');
  //     script.src = 'https://js.hsforms.net/forms/v2.js';
  //     document.body.appendChild(script);

  //     script.addEventListener('load', () => {
  //         // @TS-ignore
  //         if (typeof window !== 'undefined' && window.hbspt) {
  //             // @TS-ignore
  //             window.hbspt.forms.create({
  //                 region: 'na1',
  //                 portalId: '23461362',
  //                 formId: 'c63cb7f3-2bec-4431-9a3a-fd68b8c32672',
  //                 target: '#hubspotForm',
  //             });
  //         }
  //     });
  // }, []);

  // return (
  //     <Hubspot
  //         id="hubspotForm"
  //         className={cn('flex w-full items-center justify-center gap-4 pr-16 md:justify-end', GridColFullWidth)}
  //     ></Hubspot>
  // );
  return <div>Hubspot</div>;
}
